export enum GiftCardType {
  Digital = 'Digital',
  Physical = 'Physical',
}

export const GIFTCARD_IMAGE_URL = {
  [GiftCardType.Digital]: '/assets/gift-cards/digital-gift-card.png',
  [GiftCardType.Physical]: '/assets/gift-cards/physical-gift-card.png',
};
